import { DietTableMacros, DietTableMacrosKeys } from "../diet/types";

export const getKcal = (g: number, macro: DietTableMacrosKeys) => {
  if (macro === DietTableMacros.FAT) {
    return g * 9;
  }
  return g * 4;
};
